import { get } from 'lodash-es';
import { fetchSingleDataSource } from '@icp/form-renderer-core';
import {
  excludeData,
  getRowsFromCachedData,
  logDuplicate,
  resolveIdsToFetch,
  setRowsToCachedData,
} from './utils';

class ACLDataSource {
  constructor(props) {
    this.props = props;

    // serverSide cache, rowId => rows detail information
    this.cachedData = new Map();
    // clientSide all rows
    this.cachedAllRowsData = props.staticAllRowsData || null;

    this.fetchAllRowsPromise = null;
  }

  // 取所有数据的 id
  fetchAllIds(request) {
    const { listIdsUrl, outerFilterModel, dataExclusion, stringEqual } = this.props;

    return fetchSingleDataSource({
      dataUrl: listIdsUrl,
      filterModel: (request.filterModel || []).concat(outerFilterModel).filter(Boolean),
      searchText: request.searchText,
      sortModel: request.sortModel,
    }).then((allIds) => {
      allIds = excludeData(allIds, dataExclusion);
      return stringEqual ? allIds.map((id) => String(id)) : allIds;
    });
  }

  // 根据 id 取详细数据
  fetchRowsByIds(ids) {
    const {
      listByIdsUrl,
      translateDataResponse,
      transformDataResponse,
      selectColId,
      stringEqual,
      mapping,
    } = this.props;

    const idsToFetch = resolveIdsToFetch(this.cachedData, ids);

    return Promise.resolve(
      idsToFetch.length
        ? fetchSingleDataSource({
            dataUrl: listByIdsUrl,
            selectColId,
            transformDataResponse,
            translateDataResponse,
            queryParams: {
              ids: String(idsToFetch),
            },
          })
        : [],
    ).then(async (rows) => {
      setTimeout(() => {
        logDuplicate(rows, mapping);
      }, 100);

      setRowsToCachedData(this.cachedData, rows, stringEqual, mapping);

      return getRowsFromCachedData(this.cachedData, ids);
    });
  }

  // 根据 startRow 和 endRow 分页取数据
  fetchRowsSlice(request) {
    const {
      listUrl,
      outerFilterModel,
      dataResponseKeyPath,
      dataExclusion,
      mapping,
      translateDataResponse,
      transformDataResponse,
      selectColId,
      stringEqual,
    } = this.props;

    let count;
    return fetchSingleDataSource({
      ...request,
      dataUrl: listUrl,
      filterModel: (request.filterModel || []).concat(outerFilterModel).filter(Boolean),
      selectColId,
      dataResponseKeyPath: (res) => {
        count = res.count;
        return dataResponseKeyPath ? get(res, dataResponseKeyPath) : res;
      },
      transformDataResponse,
      translateDataResponse,
    }).then(async (rows) => {
      setTimeout(() => {
        logDuplicate(rows, mapping);
      }, 100);

      rows = excludeData(rows, dataExclusion, mapping.value);

      setRowsToCachedData(this.cachedData, rows, stringEqual, mapping);

      // 使用 ag-grid 的 serverSide 模式必须要返回 count
      return { rowData: rows, rowCount: count };
    });
  }

  // 一口去取所有数据
  fetchAllRows() {
    const {
      listUrl,
      outerFilterModel,
      dataResponseKeyPath,
      dataExclusion,
      mapping,
      translateDataResponse,
      transformDataResponse,
      stringEqual,
    } = this.props;

    if (this.fetchAllRowsPromise) {
      return this.fetchAllRowsPromise;
    }

    if (this.cachedAllRowsData) {
      return Promise.resolve(this.cachedAllRowsData);
    }

    this.fetchAllRowsPromise = fetchSingleDataSource({
      dataUrl: listUrl,
      filterModel: outerFilterModel,
      dataResponseKeyPath,
      transformDataResponse,
      translateDataResponse,
    }).then(async (rows) => {
      setTimeout(() => {
        logDuplicate(rows, mapping);
      }, 100);

      rows = excludeData(rows, dataExclusion, mapping.value);

      this.cachedAllRowsData = rows;

      setRowsToCachedData(this.cachedData, rows, stringEqual, mapping);

      return this.cachedAllRowsData;
    });

    return this.fetchAllRowsPromise;
  }
}

export default ACLDataSource;
